// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"a60312ce","378":"65b8cd19","515":"a60312ce"}[chunkId] + ".css";
};